import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { LocalizeProvider } from 'react-localize-redux'

import './index.css'
import App from './app/App'

import store from './store'

import * as serviceWorker from './serviceWorker'

ReactDOM.render(
  <LocalizeProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </LocalizeProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
